import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/public/landing/landing.component').then(m => m.LandingComponent),
    pathMatch: 'full',
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
    canActivate: [guestGuard]
  },
  {
    path: 'otp-verification',
    loadComponent: () => import('./features/auth/otp-verification/otp-verification.component').then(m => m.OtpVerificationComponent),
    canActivate: [guestGuard]
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [guestGuard]
  },
  {
    path: 'pricing',
    loadComponent: () => import('./pages/pricing/pricing.component').then(m => m.PricingPageComponent)
  },
  {
    path: 'qr/:qrCode',
    loadComponent: () => import('./pages/qr-claim/qr-claim.component').then(m => m.QrClaimComponent),
  },
  {
    path: 'features',
    loadComponent: () => import('./pages/public/landing/features/features.component').then(m => m.FeaturesComponent)
  },
  {
    path: 'how-it-works',
    loadComponent: () => import('./pages/how-works/how-works.component').then(m => m.HowWorksPageComponent)
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faqcomponent.').then(m => m.FaqComponent)
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms/terms.component').then(m => m.TermsComponent)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent)
  },
  {
    path: 'payment/success',
    loadComponent: () => import('./pages/payment-success/payment-success.component').then(m => m.PaymentSuccessComponent)
  },
  {
    path: 'payment/failure',
    loadComponent: () => import('./pages/payment-failure/payment-failure.component').then(m => m.PaymentFailureComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./layout/dashboard-layout/dashboard-layout.component').then(m => m.DashboardLayoutComponent),
    loadChildren: () => import('./layout/dashboard-layout/dashboard.routes').then(m => m.dashboardRoutes),
    canActivate: [authGuard]
  },
  {
    path: 'ihor',
    loadComponent: () => import('./pages/ihor/ihor.component').then(m => m.IhorComponent)
  },
  {
    path: 'active-code',
    loadComponent: () => import('./pages/active-code/active-code.component').then(m => m.ActiveCodeComponent)
  },
  {
    path: '**',
    redirectTo: ''
  },
];

